import { Component, Input, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { PontuacaoResultadoListComponent } from './pontuacao-resultado-list.component';
import { MatSnackBar } from '@angular/material';

@Component({
  templateUrl: './pontuacao-resultado-consulta-list.component.html',
  selector: 'pontuacao-resultado-list-consulta'
})
export class PontuacaoResultadoConsultaListComponent implements AfterViewInit {

  matricula: string;
  @ViewChild(PontuacaoResultadoListComponent) resultadoComponent: PontuacaoResultadoListComponent;
  // construtor
  constructor(private mensagem: MatSnackBar) {}

  // ngOnInit é executado ao entrar na tela
  ngAfterViewInit() {

  }

  procurar(){
    if(this.matricula){
      this.resultadoComponent.buscar(this.matricula);
    }else{
      this.mensagem.open("Digite a matrícula de um aluno(a).", 'X', { duration: 5000 });
    }
  }

}
